import { render, staticRenderFns } from "./gs-tree.vue?vue&type=template&id=4b9016d3&scoped=true&"
import script from "./gs-tree.vue?vue&type=script&lang=ts&"
export * from "./gs-tree.vue?vue&type=script&lang=ts&"
import style0 from "./gs-tree.vue?vue&type=style&index=0&id=4b9016d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9016d3",
  null
  
)

export default component.exports